<template>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
  height: 60%;
}

body {
    margin: 0;
    padding: 0;
    height: 100vh; /* Set body height to viewport height */
    background-color: #222527;
    
}




</style>
